<div class="wrapper">
  <!-- vcs.charging.mode -->
  <div class="feature-container" *ngIf="chargingModes$ | async as feature">
    <div class="feature-header">
      <h2>{{ '+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGING_MODE_TILE' | translate }}</h2>
      <mat-form-field mat-select-height-small class="charging-form-field">
        <mat-select
          [value]="feature.properties?.value?.value"
          (selectionChange)="onChargingModeSelect($event.value)"
          fieldTextContentTooltip
        >
          <mat-option
            gtm="onSelect"
            gtmAction="ChargingMode"
            gtmCategory="hems"
            fieldTextContentTooltip
            *ngFor="let mode of chargingModesArray"
            [value]="mode"
          >
            {{ getModeLabel(mode) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="icon-description">
      <img class="icon" src="/assets/icons/wallbox/green-charging-icon.svg" />
      <div>
        <h4>{{ '+INSTALLATIONS.INSTALLATION.WALLBOX.GREEN_CHARGING_TITLE' | translate }}</h4>
        <p class="capitalize-first">
          {{ '+INSTALLATIONS.INSTALLATION.WALLBOX.GREEN_CHARGING_CONTENT' | translate }}
        </p>
      </div>
    </div>
    <div class="icon-description">
      <img class="icon" src="/assets/icons/wallbox/mixed-charging-icon.svg" />
      <div>
        <h4>{{ '+INSTALLATIONS.INSTALLATION.WALLBOX.FAST_CHARGING_TITLE' | translate }}</h4>
        <p class="capitalize-first">
          {{ '+INSTALLATIONS.INSTALLATION.WALLBOX.FAST_CHARGING_CONTENT' | translate }}
        </p>
      </div>
    </div>
    <ng-container *ngIf="vehicleChargingStationAllowBatteryDischarge$ | async | ready as feature">
      <div class="feature-wrapper"></div>
      <div class="toggle-wrapper">
        <mat-slide-toggle
          [checked]="feature.properties?.active?.value"
          (click)="onVehicleChargingStation(feature)"
        ></mat-slide-toggle>
        <div class="toggle-content-wrapper">
          <div>
            <h3>{{ '+INSTALLATIONS.INSTALLATION.WALLBOX.USE_OF_BATTERY' | translate }}</h3>
          </div>
          <div>
            {{ '+INSTALLATIONS.INSTALLATION.WALLBOX.USE_OF_BATTERY_DESCRIPTION' | translate }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <!-- vcs.control.charging.limit.base -->

  <div class="feature-container" *ngIf="chargingLimit$ | async | ready as feature">
    <div class="feature-header">
      <h2>{{ '+INSTALLATIONS.INSTALLATION.WALLBOX.CURRENT_LIMIT' | translate }}</h2>
      <mat-form-field mat-select-height-small class="limit-form-field">
        <mat-select
          [value]="feature.properties?.value?.value"
          (selectionChange)="onChargingLimitSelect($event.value)"
          fieldTextContentTooltip
        >
          <mat-option
            gtm="onSelect"
            gtmAction="ChargingMode"
            gtmCategory="hems"
            fieldTextContentTooltip
            *ngFor="let limit of limits"
            [value]="limit"
          >
            {{ limit | suffix: SUFFIX.ampere }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <p class="limit-description">
      {{ '+INSTALLATIONS.INSTALLATION.WALLBOX.CURRENT_LIMIT_DESCRIPTION' | translate }}
    </p>
    <app-banner type="info">{{
      '+INSTALLATIONS.INSTALLATION.WALLBOX.CURRENT_LIMIT_BANNER' | translate
    }}</app-banner>
  </div>
</div>
